(() => {
  if (window.kanawaV2Design) return;
  window.kanawaV2Design = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const videos = new Set();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(({ target: video, isIntersecting }) => {
      if (!isIntersecting || reduced.matches || document.hidden || !video.getClientRects().length) { video.pause(); return; }
      if (!video.dataset.loaded) { video.querySelectorAll('source[data-src]').forEach(source => {source.src = source.dataset.src;}); video.load(); video.dataset.loaded = 'true'; }
      video.play().catch(() => {});
    });
  }, { threshold: .15 });

  function init(root = document) {
    root.querySelectorAll('.k2 video').forEach(video => { if (!videos.has(video)) { videos.add(video); observer.observe(video); } });
    root.querySelectorAll('.k2-footer-menus details').forEach(item => { item.open = window.innerWidth >= 750; });
  }
  function selectTab(tab, focus = false) {
    const root = tab.closest('.k2');
    root.querySelectorAll('[data-k2-tab]').forEach(button => {const selected = button === tab; button.setAttribute('aria-selected', String(selected)); button.tabIndex = selected ? 0 : -1;});
    root.querySelectorAll('[data-k2-panel]').forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
    if (focus) tab.focus();
  }
  document.addEventListener('click', event => {
    const tab = event.target.closest('[data-k2-tab]'); if (tab) selectTab(tab);
  });
  // The native quick-add modal clears its previous content 500ms after closing.
  // Let that cleanup finish before another product is requested.
  let quickCloseUntil = 0, quickPending = null, quickTimer = 0, quickMountObserver = null, quickMountTimeout = 0;
  function watchQuickModal() {
    const modal = document.getElementById('QuickAddStandard');
    if (!modal) {
      if (!quickMountObserver) {
        quickMountObserver = new MutationObserver(watchQuickModal);
        quickMountObserver.observe(document.body, {childList:true, subtree:true});
        quickMountTimeout = setTimeout(() => { quickMountObserver?.disconnect(); quickMountObserver = null; }, 10000);
      }
      return;
    }
    quickMountObserver?.disconnect(); quickMountObserver = null; clearTimeout(quickMountTimeout);
    if (modal.dataset.k2Watched) return;
    modal.dataset.k2Watched = 'true';
    let wasOpen = modal.hasAttribute('open');
    new MutationObserver(() => {
      const open = modal.hasAttribute('open');
      if (wasOpen && !open) quickCloseUntil = performance.now() + 550;
      if (open) quickPending = null;
      wasOpen = open;
    }).observe(modal, {attributes:true, attributeFilter:['open']});
  }
  window.addEventListener('click', event => {
    const opener = event.target.closest('.k2-quick[data-product-url]');
    if (!opener) return;
    watchQuickModal();
    const delay = quickCloseUntil - performance.now();
    if (delay > 0) {
      event.preventDefault(); event.stopImmediatePropagation(); clearTimeout(quickTimer);
      quickTimer = setTimeout(() => { if (opener.isConnected && !document.getElementById('QuickAddStandard')?.hasAttribute('open')) opener.click(); }, delay);
      return;
    }
    if (quickPending?.isConnected && quickPending.classList.contains('loading')) {
      event.preventDefault(); event.stopImmediatePropagation(); return;
    }
    quickPending = opener;
  }, true);
  window.addEventListener('keydown', event => { if(event.key === 'Escape') clearTimeout(quickTimer); });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('[data-k2-tab]'); if (!tab || !['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(event.key)) return;
    const tabs = [...tab.closest('[role="tablist"]').querySelectorAll('[data-k2-tab]')]; let index = tabs.indexOf(tab);
    index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length-1 : (index + (['ArrowRight','ArrowDown'].includes(event.key)?1:-1) + tabs.length) % tabs.length;
    event.preventDefault(); selectTab(tabs[index], true);
  });
  document.addEventListener('shopify:block:select', event => { const panel = event.target.closest('[data-k2-panel]'); if (panel) {const tab = document.getElementById(panel.getAttribute('aria-labelledby')); if (tab) selectTab(tab);} });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => { event.target.querySelectorAll('video').forEach(video => {observer.unobserve(video); video.pause(); videos.delete(video);}); });
  document.addEventListener('visibilitychange', () => { if(document.hidden) videos.forEach(video => video.pause()); else videos.forEach(video => {observer.unobserve(video); observer.observe(video);}); });
  reduced.addEventListener('change', () => {videos.forEach(video => {video.pause(); observer.unobserve(video); observer.observe(video);});});
  let mobile = window.innerWidth < 750;
  window.addEventListener('resize', () => {const next = window.innerWidth < 750;if(next !== mobile){mobile = next;document.querySelectorAll('.k2-footer-menus details').forEach(item => {item.open = !mobile;});}});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
})();
